import { render, staticRenderFns } from "./AppViewFooter.vue?vue&type=template&id=6ff5ff15&lang=pug&"
import script from "./AppViewFooter.vue?vue&type=script&lang=js&"
export * from "./AppViewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports